const albums2022 = [
  {
    id: 1,
    title: {
      english: "Meritorious Worker Award - 2019",
      marathi: "गुणवंत कामगार पुरस्कार - २०१९"
    },
    year: 2022,
    photos: [
      {
        id: 1,
        title: {
          english: "Kamgar Mitra Haffkine Bio-Pharmaceutical Corporation",
          marathi: "कामगार मित्र हाफकिन जीव-औषध निर्माण महामंडळ"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_01.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_01.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_01.jpg"
      },
      {
        id: 2,
        title: {
          english: "Kamgar Bhushan Mr. Rajendra Hiraman Wag - Cummins India Ltd. Kothrud Pune",
          marathi: "कामगार भूषण श्री. राजेंद्र हिरामण वाघ - कमिन्स इंडिया लि. कोथरूड पुणे"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_02.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_02.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_02.jpg"
      },
      {
        id: 3,
        title: {
          english: "Mrs. Najmabi Gulab Sheikh - Kallappanna Awade Ichalkaranji Janata Cooperative Bank Ichalkaranji",
          marathi: "श्रीमती नजमाबी गुलाब शेख - कल्लाप्पाण्णा आवाडे इचलकरंजी जनता सहकारी बँक इचलकरंजी"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_03.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_03.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_03.jpg"
      },
      {
        id: 4,
        title: {
          english: "Mr. Kiran Chandrakant Deshmukh - Alpha Laval India Dapodi Pune",
          marathi: "श्री. किरण चंद्रकांत देशमुख - अल्फा लवाल इंडिया दापोडी पुणे"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_04.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_04.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_04.jpg"
      },
      {
        id: 5,
        title: {
          english: "Dr. Smita Samir Mahurkar - L. I. C. Nagpur",
          marathi: "डॉ. स्मिता समीर माहुरकर - एल. आय. सी. नागपूर"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_05.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_05.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_05.jpg"
      },
      {
        id: 6,
        title: {
          english: "Mr. Leeladhar Ramchandra Davande - Indorama Synthetics India Ltd. Butibori Nagpur",
          marathi: "श्री. लीलाधर रामचंद्र दवंडे - इंडोरामा सिंथेटिक्स इंडिया लि. बुटीबोरी नागपूर"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_06.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_06.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_06.jpg"
      },
      {
        id: 7,
        title: {
          english: "Mr. Hanumant Ramchandra Jadhav - Lokmanya Hospital Nigdi Pune",
          marathi: "श्री. हनुमंत रामचंद्र जाधव - लोकमान्य हॉस्पिटल निगडी पुणे"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_07.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_07.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_07.jpg"
      },
      {
        id: 8,
        title: {
          english: "Mr. Santosh Marotrao Tajne - Chandrapur Super Thermal Power Generation Center - Urja Nagar Chandrapur",
          marathi: "श्री. संतोष मारोतराव ताजने - चंद्रपूर महाऔष्णिक विद्युत निर्मिती केंद्र - उर्जा नगर चंद्रपूर"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_08.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_08.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_08.jpg"
      },
      {
        id: 9,
        title: {
          english: "Mr. Kiran Rajaram Jadhav - Haffkine Bio-Pharmaceutical Corporation Mumbai",
          marathi: "श्री. किरण राजाराम जाधव - हाफकिन जीव औषध निर्माण महामंडळ मुंबई"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_09.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_09.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_09.jpg"
      },
      {
        id: 10,
        title: {
          english: "Mrs. Mahananda Bhagwanrao Kendre - Maharashtra State Road Transport Corporation Parbhani",
          marathi: "श्रीमती महानंदा भगवानराव केंद्रे - महाराष्ट्र राज्य मार्ग परिवहन महामंडळ परभणी"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_10.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_10.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_10.jpg"
      },
      {
        id: 11,
        title: {
          english: "Mr. Suresh Shrinathrao Borde - Bajaj Auto Ltd. Waluj Aurangabad",
          marathi: "श्री. सुरेश श्रीनाथराव बोर्डे - बजाज ऑटो लि. वाळूज औरंगाबाद"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_11.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_11.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_11.jpg"
      },
      {
        id: 12,
        title: {
          english: "Mr. Kuldeep Janardan Sawant - Maharashtra State Road Transport Corporation Osmanabad",
          marathi: "श्री. कुलदीप जनार्दन सावंत - महाराष्ट्र राज्य मार्ग परिवहन महामंडळ उस्मानाबाद"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_12.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_12.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_12.jpg"
      },
      {
        id: 13,
        title: {
          english: "Mr. Balasahab Limbraj Salunke - Tata Motors Company Pimpri Pune",
          marathi: "श्री. बाळासाहेब लिंबराज साळुंके - टाटा मोटर्स कंपनी पिंपरी पुणे"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_13.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_13.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_13.jpg"
      },
      {
        id: 14,
        title: {
          english: "Mr. Shivaji Subarao Patil - Tata Motors Ltd. Pimpri Pune",
          marathi: "श्री. शिवाजी सुबराव पाटील - टाटा मोटर्स लि. पिंपरी पुणे"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_14.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_14.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_14.jpg"
      },
      {
        id: 15,
        title: {
          english: "Mr. Shravan Babnrao Kolanurkar - Maharashtra State Power Distribution Company Aurangabad",
          marathi: "श्री. श्रावण बाबनराव कोळनूरकर - महाराष्ट्र राज्य विद्युत वितरण कंपनी औरंगाबाद"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_15.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_15.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_15.jpg"
      },
      {
        id: 16,
        title: {
          english: "Mr. Panjabrao Govindrao More - Prabodhan Prakashan Daily Samana Aurangabad",
          marathi: "श्री. पंजाबराव गोविंदराव मोरे - प्रबोधन प्रकाशन दैनिक सामना औरंगाबाद"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_16.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_16.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_16.jpg"
      },
      {
        id: 17,
        title: {
          english: "Mr. Yogesh Ravan Kapadnis - Maharashtra State Power Generation Company Super Thermal Power Center Eklahere Nashik",
          marathi: "श्री. योगेश रावण कापडणीस - महा. राज्य वीज निर्मिती कं. औष्णिक विद्युत केंद्र एकलहरे नाशिक"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_17.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_17.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_17.jpg"
      },
      {
        id: 18,
        title: {
          english: "Mr. Rajesh Ramakant Vartak - Tata Steel Ltd. Tarapur Palghar",
          marathi: "श्री. राजेश रमाकांत वर्तक - टाटा स्टील लि. तारापूर पालघर"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_18.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_18.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_18.jpg"
      },
      {
        id: 19,
        title: {
          english: "Mr. Nitin Ramchandra Patil - Maharashtra State Road Transport Corporation Divisional Workshop Chandannagar Miraj",
          marathi: "श्री. नितीन रामचंद्र पाटील - महा. राज्य मार्ग परिवहन महामंडळ विभागीय कार्यशाळा चंदननगर मिरज"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_19.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_19.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_19.jpg"
      },
      {
        id: 20,
        title: {
          english: "Mr. Rajeshkumar Omkarmal Rajore - Vidarbha Publication Daily Deshonnati Akola",
          marathi: "श्री. राजेशकुमार ओंकारमल राजोरे - विदर्भ पब्लिकेशन दैनिक देशोन्नती अकोला"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_20.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_20.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_20.jpg"
      },
      {
        id: 21,
        title: {
          english: "Mr. Vitthal Sakharam Tambe - Godrej & Boyce Manufacturing Company Shirval Satara",
          marathi: "श्री. विठ्ठल सखाराम तांबे - गोदरेज अँड बॉईज मॅन्यु. कंपनी शिरवळ सातारा"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_21.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_21.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_21.jpg"
      },
      {
        id: 22,
        title: {
          english: "Mr. Gajanan Krishnaji Pise - Sah. M. Shankarrao Mohite Patil Sah. Sugar Factory Akaluj Solapur",
          marathi: "श्री. गजानन कृष्णाजी पिसे - सह. म. शंकरराव मोहिते पाटील सह. साखर कारखाना अकलूज सोलापूर"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_22.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_22.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_22.jpg"
      },
      {
        id: 23,
        title: {
          english: "Mr. Pankaj Govardhanrao Thakre - Grindwell Norton Ltd. Butibori Nagpur",
          marathi: "श्री. पंकज गोवर्धनराव ठाकरे - ग्राईंडवेल नॉर्टन लि. बुटीबोरी नागपूर"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_23.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_23.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_23.jpg"
      },
      {
        id: 24,
        title: {
          english: "Mr. Sanjeev Ram Mane - Cummins India Ltd. Kothrud Pune",
          marathi: "श्री. संजीव राम माने - कमिन्स इंडिया लि. कोथरूड पुणे"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_24.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_24.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_24.jpg"
      },
      {
        id: 25,
        title: {
          english: "Mr. Arun Vaijnath Bhallekar - Kohler Power India Chikhalthana Aurangabad",
          marathi: "श्री. अरुण वैजनाथ भालेकर - कोहलर पावर इंडिया चिकलठाणा औरंगाबाद"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_25.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_25.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_25.jpg"
      },
      {
        id: 26,
        title: {
          english: "Mr. Babn Bhikaji Bharskar - Maharashtra State Power Transmission Company - Ballarshah Chandrapur",
          marathi: "श्री. बबन भिकाजी भारस्कर - महा. राज्य विद्युत पारेषण कंपनी - बल्लारशहा चंद्रपूर"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_26.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_26.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_26.jpg"
      },
      {
        id: 27,
        title: {
          english: "Mr. Dattatray Pandurang Gayakwad - Maharashtra State Road Transport Corporation Central Workshop Pune",
          marathi: "श्री. दत्तात्रय पांडुरंग गायकवाड - महा. राज्यमार्ग परिवहन महामंडळ मध्यवर्ती कार्यशाळा पुणे"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_27.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_27.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_27.jpg"
      },
      {
        id: 28,
        title: {
          english: "Sanjeev Ananda Suravade - Central Railway Electric Engine Factory - Bhusawal",
          marathi: "संजीव आनंदा सुरवाडे - मध्य रेल्वे विद्युत इंजिन कारखाना - भुसावळ"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_28.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_28.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_28.jpg"
      },
      {
        id: 29,
        title: {
          english: "Mr. Vilas Hasuram Mhatre - Navi Mumbai Municipal Corporation Transport Undertaking Belapur Navi Mumbai",
          marathi: "श्री. विलास हसुराम म्हात्रे - नवी मुंबई महानगर पालिका परिवहन उपक्रम बेलापूर नवी मुंबई"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_29.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_29.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_29.jpg"
      },
      {
        id: 30,
        title: {
          english: "Mr. Tanaji Eknath Nikam - Canara Bank Ghatkopar Mumbai",
          marathi: "श्री. तानाजी एकनाथ निकम - कॅनरा बँक घाटकोपर मुंबई"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_30.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_30.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_30.jpg"
      },
      {
        id: 31,
        title: {
          english: "Mr. Avinash Eknath Daund - Government Central Printing Press - Charni Road Mumbai",
          marathi: "श्री. अविनाश एकनाथ दौंड - शासकीय मध्यवर्ती मुद्रणालय - चर्नी रोड मुंबई"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_31.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_31.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_31.jpg"
      },
      {
        id: 32,
        title: {
          english: "Mr. Vinod Narayan Vichare - State Bank of India Lalbagh Mumbai",
          marathi: "श्री. विनोद नारायण विचारे - भारतीय स्टेट बँक लालबाग मुंबई"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_32.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_32.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_32.jpg"
      },
      {
        id: 33,
        title: {
          english: "Mr. Sampat Vishnu Taware - Mahanand Dairy Goregaon Mumbai",
          marathi: "श्री. संपत विष्णू तावरे - महानंद दुग्धशाळा गोरेगाव मुंबई"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_33.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_33.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_33.jpg"
      },
      {
        id: 34,
        title: {
          english: "Mr. Suryakant Baburao Padkonde - Bajaj Auto - Waluj Aurangabad",
          marathi: "श्री. सुर्यकांत बाबुराव पद्कोंडे - बजाज ऑटो - वाळूज औरंगाबाद"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_34.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_34.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_34.jpg"
      },
      {
        id: 35,
        title: {
          english: "Mr. Sakharam Ramchandra Indore - Godrej & Boyce Company - Vikroli Mumbai",
          marathi: "श्री. सखाराम रामचंद्र इंदोरे - गोदरेज अँड बॉईज कंपनी - विक्रोळी मुंबई"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_35.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_35.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_35.jpg"
      },
      {
        id: 36,
        title: {
          english: "Mr. Nitin Ramdas Benkar - Sah. M. Shankarrao Mohite Patil Sah. Sugar Factory Solapur",
          marathi: "श्री. नितीन रामदास बेनकर - सह. म. शंकरराव मोहिते पाटील सह. साखर का. सोलापूर"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_36.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_36.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_36.jpg"
      },
      {
        id: 37,
        title: {
          english: "Mr. Kalooram Pandurang Landge - Pune Municipal Transport Corporation Pune",
          marathi: "श्री. काळूराम पांडुरंग लांडगे - पुणे महानगर परिवहन महामंडळ पुणे"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_37.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_37.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_37.jpg"
      },
      {
        id: 38,
        title: {
          english: "Mr. Dilip Vitthalrao Thakre - Central Prison Printing Press Nagpur",
          marathi: "श्री. दिलीप विठ्ठलराव ठाकरे - मध्यवर्ती कारागृह मुद्रणालय नागपूर"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_38.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_38.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_38.jpg"
      },
      {
        id: 39,
        title: {
          english: "Mr. Imranali Ramjan Shikalgar - Kirloskar Brothers Sangli",
          marathi: "श्री. इम्रानअली रमजान शिकलगार - किर्लोस्कर ब्रदर्स सांगली"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_39.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_39.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_39.jpg"
      },
      {
        id: 40,
        title: {
          english: "Mr. Vaibhav Harishchandra Bhoir - Thane Municipal Corporation Thane",
          marathi: "श्री. वैभव हरिश्चंद्र भोईर - ठाणे महानगरपालिका ठाणे"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_40.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_40.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_40.jpg"
      },
      {
        id: 41,
        title: {
          english: "Mrs. Sangita Dhananjay Bhoite - Shriram Shetkari Kamgar Sah. Grahak Sanstha Satara",
          marathi: "सौ. संगीता धनंजय भोईटे - श्रीराम शेतकरी कामगार सह. ग्राहक संस्था सातारा"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_41.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_41.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_41.jpg"
      },
      {
        id: 42,
        title: {
          english: "Mr. Ram Barka Sarang - Mazgaon Dock Ship Builders - Mazgaon Mumbai",
          marathi: "श्री. राम बारका सारंग - माझगाव डॉक शिप बिल्डर्स - माझगाव मुंबई"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_42.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_42.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_42.jpg"
      },
      {
        id: 43,
        title: {
          english: "Mr. Ajay Yashwant Dalvi - Symbolic Fabric - Bhiwandi Thane",
          marathi: "श्री. अजय यशवंत दळवी - सिम्बोलिक फॅब्रिक - भिवंडी ठाणे"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_43.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_43.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_43.jpg"
      },
      {
        id: 44,
        title: {
          english: "Mr. Jaywant Yashwant Kupte - Bharat Bijli Ltd. Airoli Navi Mumbai",
          marathi: "श्री. जयवंत यशवंत कुपटे - भारत बिजली लि. ऐरोली नवी मुंबई"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_44.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_44.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_44.jpg"
      },
      {
        id: 45,
        title: {
          english: "Mr. Chandrakant Mahadev More - Bank of Maharashtra Mumbai",
          marathi: "श्री. चंद्रकांत महादेव मोरे - बँक ऑफ महाराष्ट्र मुंबई"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_45.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_45.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_45.jpg"
      },
      {
        id: 46,
        title: {
          english: "Mr. Dinkar Bapu Adasul - Menon Piston Rings - Hatkanangale Kolhapur",
          marathi: "श्री. दिनकर बापू आडसूळ - मेनन पिस्टन रिंग्स - हातकणंगले कोल्हापूर"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_46.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_46.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_46.jpg"
      },
      {
        id: 47,
        title: {
          english: "Mr. Dilip Namdev Pasalkar - Cummins India Kothrud Pune",
          marathi: "श्री. दिलीप नामदेव पासलकर - कमिन्स इंडिया कोथरूड पुणे"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_47.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_47.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_47.jpg"
      },
      {
        id: 48,
        title: {
          english: "Mr. Vijay Sambhaji Arekar - S. B. Riselers Kagal Kolhapur",
          marathi: "श्री. विजय संभाजी आरेकर - एस. बी. रिसेलर्स कागल कोल्हापूर"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_48.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_48.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_48.jpg"
      },
      {
        id: 49,
        title: {
          english: "Mr. Ganesh Yashwant Kale - Currency Note Press Nashik",
          marathi: "श्री. गणेश यशवंत काळे - करन्सी नोट प्रेस नाशिक"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_49.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_49.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_49.jpg"
      },
      {
        id: 50,
        title: {
          english: "Mr. Sanjay Shantaram Tavade - Mumbai Port Trust Mumbai",
          marathi: "श्री. संजय शांताराम तावडे - मुंबई पोर्ट ट्रस्ट मुंबई"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_50.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_50.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_50.jpg"
      },
      {
        id: 51,
        title: {
          english: "Mr. Vijay Tukaram Rankhamb - Maharashtra State Power Distribution Company Parbhani",
          marathi: "श्री. विजय तुकाराम रणखांब - महाराष्ट्र राज्य विद्युत वितरण कंपनी परभणी"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_51.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_51.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_51.jpg"
      },
      {
        id: 52,
        title: {
          english: "Mr. Ashok Su-yaba Aldar - Maharashtra State Power Distribution Company Pandharpur",
          marathi: "श्री. अशोक सु-याबा आलदर - महाराष्ट्र राज्य विद्युत वितरण कंपनी पंढरपूर"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_52.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_52.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_52.jpg"
      },
      {
        id: 53,
        title: {
          english: "Mr. Balaji Kisan Nalwade - Kirloskar Brothers Ltd. Kirloskarvadi Palus Sangli",
          marathi: "श्री. बालाजी किसन नलवडे - किर्लोस्कर ब्रदर्स लि. किर्लोस्करवाडी पलूस सांगली"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_53.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_53.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2022/20220710_53.jpg"
      }
    ]
  }
];

export default albums2022;
